<template>
    <div class="closest-wrapper" id="closest-wrapper-event">
      <div class="slideout-close" @click="$parent.closeSlideout()">
          <i class="fas fa-times"></i>
      </div>
        <div class="slideout-inner">
            <div class="slideout-header">
                <div class="slideout-upper-header">
                    <h4> Produse </h4>
                    <div class="search-form slideout-search">
                        <input
                                class="search-input"
                                type="search"
                                :placeholder="$t('placeholder.cautaProdus')"
                                name="q"
                                id="product-search"
                                v-model="search_products"
                                autocomplete="off">
                        <span class="focus-input"></span>
                        <span class="symbol-input" >
                          <i class="fas fa-search"></i>
                      </span>
                    </div>
                </div>
                <div class="slideout-bottom-header">
                    <div class="tbl-header">
                      <table cellpadding="0" cellspacing="0" border="0">
                        <thead>
                          <tr>
                            <th colspan="2" v-bind:class="[selected_search_header === 'name' || selected_search_header === null ? 'item-header-active' : '', '']" @click="selected_search_header !='name' ? selected_search_header ='name' : selected_search_header = null">
                              <div class="table-heading-name table-heading-item" >
                                <p> Nume </p>
                              </div>
                            </th>
                            <th colspan="2" v-bind:class="[selected_search_header === 'manufacturer' || selected_search_header === null ? 'item-header-active' : '', '']" @click="selected_search_header != 'manufacturer' ? selected_search_header ='manufacturer' : selected_search_header = null">
                              <div class="table-heading-item table-heading-manufacturer">
                                <p> Producator </p>
                              </div>
                            </th>
                            <th colspan="2" v-bind:class="[selected_search_header === 'external' ? 'item-header-active' : '', '']" @click="selected_search_header != 'external' ? selected_search_header ='external' : selected_search_header = null">
                              <div class="table-heading-item table-heading-ecode">
                                <p> Cod Extern </p>
                              </div>
                            </th>
                            <th v-bind:class="[selected_search_header === 'internal' ? 'item-header-active' : '', '']" @click="selected_search_header != 'internal' ? selected_search_header ='internal' : selected_search_header = null">
                              <div class="table-heading-item table-heading-icode">
                                <p> Cod Intern </p>
                              </div>
                            </th>
                            <th>
                              <div class="table-heading-item table-heading-price">
                                <p> Pret </p>
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                </div>
            </div>
        </div>
        <section id="product-section">

        <div class="tbl-content">
          <div role="tablist">
            <div class="closest-wrapper">
              <table cellpadding="0" border="0" class="table-striped" id="content-table-products">
                <tbody>
                  <tr v-for="(product, index) in products" :key="product.id" :tabindex="index">
                    <td colspan="2">
                      <div class="table-row-name table-row-item" :id="'popover-' + index">
                        <button :data-active="index" :data-popover="'popover-' + index" v-b-toggle="'accordion' + index" variant="primary" role="tabpanel" :id="'btn-collapse' + index" class="collapsed" @keypress.enter="focusInsideInput(index)" @click="focusInsideInput(index)">
                            <i class="fas fa-sort-down"></i>
                            <p> {{product.name}}</p>
                        </button>
                      </div>
                      <b-collapse :id="'accordion' + index" accordion="my-accordion" role="tabpanel">
                          <div class="item-row-lower" :id="'focus_' + index">
                              <div class="warehouse-list" v-if="warehouses">
                                  <ul>
                                      <li v-for="warehouse in warehouses.slice(0, Math.ceil(warehouses.length/2))" :key="warehouse.id">
                                          <p> {{warehouse.key}} </p>
                                          <div class="item-stock-status">
                                              <p class="item-stock1"> {{getQty(product.stock, warehouse.id)}} </p>
                                              <p  class="item-stock2"> {{getQtyReserved(product.stock, warehouse.id)}} </p>
                                          </div>
                                          <input v-if="userWarehouses.find(userWrh => userWrh.id === warehouse.id)" type="number" v-on:keyup.enter="addItem(product)" :data-product="product.id" :data-warehouse-id="warehouse.id" :data-warehouse-name="warehouse.name" :data-warehouse-key="warehouse.key">
                                      </li>
                                  </ul>
                                  <ul>
                                      <li v-for="warehouse in warehouses.slice(Math.ceil(warehouses.length/2), warehouses.length)" :key="warehouse.id">
                                          <p> {{warehouse.key}} </p>
                                          <div class="item-stock-status">
                                              <p class="item-stock1"> {{getQty(product.stock, warehouse.id)}} </p>
                                              <p  class="item-stock2"> {{getQtyReserved(product.stock, warehouse.id)}} </p>
                                          </div>
                                          <input v-if="userWarehouses.find(userWrh => userWrh.id === warehouse.id)" type="number" v-on:keyup.enter="addItem(product)" :data-product="product.id" :data-warehouse-id="warehouse.id" :data-warehouse-name="warehouse.name" :data-warehouse-key="warehouse.key">
                                      </li>
                                  </ul>
                              </div>
                              <div class="order-add-product">
                                  <button type="button" @click="addItem(product)" tabindex="-1">
                                      <i class="fas fa-plus"></i>
                                      <span> {{$t('txt.adaugaProdus')}} </span>
                                  </button>
                              </div>
                              <b-popover :target="'popover-' + index" placement="bottomright" triggers="focus hover"  delay="50">
                                  <template slot="title" class="popover-title">
                                      {{product.name}}
                                  </template>
                                  <div class="warehouse-list" v-if="warehouses">
                                      <ul>
                                          <li v-for="warehouse in warehouses.slice(0, Math.ceil(warehouses.length/2))" :key="warehouse.id">
                                              <p> {{warehouse.key}} </p>
                                              <div class="item-stock-status">
                                                  <p class="item-stock1"> {{getQty(product.stock, warehouse.id)}} </p>
                                                  <p  class="item-stock2"> {{getQtyReserved(product.stock, warehouse.id)}} </p>
                                              </div>
                                          </li>
                                      </ul>
                                      <ul>
                                          <li v-for="warehouse in warehouses.slice(Math.ceil(warehouses.length/2), warehouses.length)" :key="warehouse.id">
                                              <p> {{warehouse.key}} </p>
                                              <div class="item-stock-status">
                                                  <p class="item-stock1"> {{getQty(product.stock, warehouse.id)}} </p>
                                                  <p  class="item-stock2"> {{getQtyReserved(product.stock, warehouse.id)}} </p>
                                              </div>
                                          </li>
                                      </ul>
                                  </div>
                              </b-popover>
                          </div>
                      </b-collapse>
                    </td>
                    <td colspan="2">
                      <div class="table-row-item table-row-manufacturer">
                        <p> {{product.manufacturer || '-'}} </p>
                      </div>
                    </td>
                    <td colspan="2">
                      <div class="table-row-item table-row-ecode">
                        <p> {{product.cod_extern || '-'}} </p>
                      </div>
                    </td>
                    <td>
                      <div class="table-row-item table-row-icode">
                        <p> {{product.cod_intern || '-'}}  </p>
                      </div>
                    </td>
                    <td>
                      <div class="table-row-item table-row-price">
                        <p> {{product.prices ? product.prices.pp_amanunt : 0 | formatPrice}} </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      <!-- <div class="item-slot" v-for="(product, index) in products" :key="product.id" :tabindex="index">
          <div class="item-row-upper">
              <div class="item-name-slot" :id="'popover-' + index">
                  <b-btn @click="focusInsideInput(index)" :data-active="index" :data-popover="'popover-' + index" v-b-toggle="'accordion' + index" variant="primary" role="tabpanel" :id="'btn-collapse' + index" class="collapsed" @keypress.enter="focusInsideInput(index)">
                      <i class="fas fa-ellipsis-h"></i>
                      <h4> {{product.name}}</h4>
                  </b-btn>
              </div>
              <div class="item-manufacturer">
                  <p> {{product.manufacturer || '-'}} </p>
              </div>
              <div class="item-internal-code">
                  <p> {{product.cod_intern || '-'}}  </p>
              </div>
              <div class="item-external-code">
                  <p> {{product.cod_extern || '-'}} </p>
              </div>
              <div class="item-price">
                  <p> {{product.prices ? product.prices.pp_amanunt : 0 | formatPrice}} </p>
              </div>
          </div>
      </div> -->

      </section>
    </div>
</template>

<script>
import ProductsService from '../api-services/products.service'
import { EventBus } from '../main.js'

export default {
  name: 'Products',
  props: [
    'userWarehouses',
    'warehouses'
  ],
  data () {
    return {
      products: [],
      lastDataActive: null,
      selected_search_header: null,
      meta_products_page: 1,
      search_products: '',
      globalKeyPresed: false,
      incoimmingProducts: false
    }
  },
  watch: {
    search_products: _.debounce(async function (val) {
      let response = await ProductsService.getSearchData({ q: val, per_page: 40, q_in: this.selected_search_header })
      this.products = response.data.data
      this.meta_products = response.data.meta
      this.meta_products_page = 1
      this.lastDataActive = null
    }, 20)
  },
  computed: {
  },
  methods: {
    closeSlideout () {
      this.action_button_state = undefined
      window.$('.action-button').removeClass('action-button-active')
      window.$('#offers-slideout').removeClass('slideout-open')
      window.$('#product-slideout').removeClass('slideout-open')
      window.$('#page-content-wrapper').removeClass('changed-position')
    },
    focusInsideInput (index) {
      this.$root.$emit('bv::hide::popover')
      if (!this.globalKeyPresed) {
        this.globalKeyPresed = true
        this.lastDataActive = index
        let dataFocus = 'focus_' + index
        let panel = document.getElementById(dataFocus)
        let inputInside = panel.getElementsByTagName('input')[0]
        let vm = this
        // let iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        // if (iOS) {
        //   alert('I AM IOS')
        // } else {
        //   alert('I AM NOT IOS')
        // }
        setTimeout(function () {
          inputInside.focus()
          vm.globalKeyPresed = false
        }, 350)
      }
    },
    resetCollapseState () {
      let vm = this
      let existCollapse = 0
      let collapsedAriaBtn = window.$('[aria-expanded=true]').attr('aria-controls')
      if (collapsedAriaBtn) {
        existCollapse = 1
        vm.$root.$emit('bv::toggle::collapse', collapsedAriaBtn)
      }
      if (vm.lastDataActive >= 0 && vm.lastDataActive <= vm.products.length) {
        window.$('[data-active=' + vm.lastDataActive + ']').focus()
        if (existCollapse) {
          vm.$root.$emit('bv::hide::popover', window.$('[data-active=' + vm.lastDataActive + ']').attr('data-popover'))
          setTimeout(function () {
            vm.$root.$emit('bv::show::popover', window.$('[data-active=' + vm.lastDataActive + ']').attr('data-popover'))
          }, 450)
        }
      }
    },
    getQty (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return parseInt(element.warehouse_id) === parseInt(warehouseId)
        })
        if (stock) {
          return stock.qty
        }
      }
      return 0
    },
    getQtyReserved (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return parseInt(element.warehouse_id) === parseInt(warehouseId)
        })
        if (stock) {
          return stock.reserved
        }
      }
      return 0
    },
    getProducts (params, rest = false) {
      return new Promise((resolve, reject) => {
      // this.products = null
        if (!this.incoimmingProducts) {
          this.incoimmingProducts = true
          ProductsService.getAll((params || { per_page: 20 }))
            .then((response) => {
              if (response.data.data.length > 0) {
                if (this.products != null) {
                  if (rest) {
                    this.products = response.data.data
                    this.meta_products_page = 1
                  } else {
                    this.products.push.apply(this.products, response.data.data)
                  }
                } else {
                  this.products = response.data.data
                }
                for (let i = 0; i < this.products.length; i++) {
                  this.$set(this.products[i], 'discount', null)
                  this.$set(this.products[i], 'addition', null)
                }
              }
              this.meta_products = response.data.meta
              this.incoimmingProducts = false
              resolve(response)
            })
            .catch((error) => {
              this.incoimmingProducts = false
              console.log(error)
              reject(error)
            })
        }
      })
    },
    addItem (product) {
      let inputs = document.querySelectorAll("input[data-product='" + product.id + "']")
      let data = {
        product: product,
        inputs: inputs
      }
      this.$emit('addItem', data)
    }
  },
  mounted () {
    let vm = this
    let cauta = document.getElementById('product-search')
    let timeout = null
    cauta.addEventListener('input', function (e) {
      if (timeout !== null) {
        clearTimeout(timeout)
      }
      timeout = setTimeout(function () {
        vm.lastDataActive = null
        vm.getProducts({ q: vm.search_products, per_page: 40, q_in: vm.selected_search_header }, true)
      }, 1000)
    })
    EventBus.$on('doAction', (data) => {
      vm.lastDataActive = null
    })

    document.getElementById('closest-wrapper-event').addEventListener('keydown', event => {
      let element = document.getElementById('product-slideout')
      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.closest('.closest-wrapper') !== null && element.classList.contains('slideout-open') && document.activeElement.getAttribute('data-addition-active') === null && document.activeElement.getAttribute('data-discount-active') === null) {
        event.preventDefault()
        if (this.globalKeyPresed === false) {
          if (event.keyCode === 40) {
            vm.lastDataActive = vm.lastDataActive == null ? 0 : vm.lastDataActive + 1
            if (vm.lastDataActive === vm.products.length) {
              vm.lastDataActive--
            }
            if (vm.lastDataActive > this.meta_products_page * 40 - 10) {
              this.getProducts({ per_page: 40, page: ++this.meta_products_page, q: vm.search_products })
            }
          } else {
            vm.lastDataActive = vm.lastDataActive < 1 ? 0 : vm.lastDataActive - 1
          }
          vm.resetCollapseState()
        }
      }
      if (event.keyCode === 13 && this.globalKeyPresed === true) {
        event.preventDefault()
      }
    })
    window.$('#closest-wrapper-event .tbl-content').scroll(function () {
      if (window.$('#closest-wrapper-event .tbl-content').scrollTop() + window.$('#closest-wrapper-event #product-section').height() > window.$('#closest-wrapper-event #content-table-products').height()) {
        vm.getProducts({ per_page: 40, page: ++vm.meta_products_page, q: vm.search_products })
      }
    })
  },
  async created () {
    this.getProducts({ per_page: 40 })
  }
}
</script>
